(function () {
  function init(root) {
    if (root.dataset.kobuFaqInit === '1') return;
    root.dataset.kobuFaqInit = '1';

    root.querySelectorAll('details').forEach(function (details) {
      var summary = details.querySelector('summary');
      var answer = details.querySelector('.kobu-faq-a');
      if (!summary || !answer) return;

      summary.addEventListener('click', function (event) {
        event.preventDefault();
        var opening = !details.hasAttribute('open');

        if (opening) {
          details.setAttribute('open', '');
          answer.style.maxHeight = '0px';
          answer.style.opacity = '0';
          answer.style.paddingBottom = '0px';
          requestAnimationFrame(function () {
            answer.style.maxHeight = answer.scrollHeight + 'px';
            answer.style.opacity = '0.75';
            answer.style.paddingBottom = '22px';
          });
        } else {
          answer.style.maxHeight = answer.scrollHeight + 'px';
          requestAnimationFrame(function () {
            answer.style.maxHeight = '0px';
            answer.style.opacity = '0';
            answer.style.paddingBottom = '0px';
          });
          answer.addEventListener('transitionend', function close(event) {
            if (event.propertyName !== 'max-height') return;
            details.removeAttribute('open');
            answer.removeEventListener('transitionend', close);
          });
        }
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-kobu-faq]').forEach(init);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  document.addEventListener('shopify:section:load', boot);
})();
